import { IconButton, Stack, Typography } from "@mui/material";
import { MoreVertIcon } from "../images/MoreVertIcon";
import { useState } from "react";
import { StyledMenu } from "../ui";
import { RecommendedReasonHeader } from "./RecommendedReasonHeader";
import { RecommendedAccountActionBlock } from "./RecommendedAccountActionBlock";

type Props = {
  id: string;
  reason: string;
  isDisabled: boolean;
};

export const RecommendedMenuBtn = ({ id, reason, isDisabled }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        disableRipple
        onClick={handleClick}
        sx={{
          borderRadius: "6px",
          width: "32px",
          height: "32px",
          backgroundColor: open ? "#E6E6E6" : "transparent",
          "&:hover": {
            backgroundColor: "#E6E6E6",
          },
        }}
        disabled={isDisabled}
      >
        <MoreVertIcon width="24" />
      </IconButton>

      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
            padding: "12px 16px",
            maxWidth: "320px",
          },
        }}
      >
        <Stack gap={"16px"}>
          <Stack gap={"4px"}>
            <RecommendedReasonHeader />
            <Typography variant={"body1"} sx={{ color: "#464646" }}>
              {reason}
            </Typography>
          </Stack>
          <RecommendedAccountActionBlock ids={[id]} />
        </Stack>
      </StyledMenu>
    </>
  );
};
